import { render, staticRenderFns } from "./padlet_list.vue?vue&type=template&id=4ad85d08&scoped=true&"
import script from "./padlet_list.vue?vue&type=script&lang=js&"
export * from "./padlet_list.vue?vue&type=script&lang=js&"
import style0 from "./padlet_list.vue?vue&type=style&index=0&id=4ad85d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad85d08",
  null
  
)

export default component.exports